'use client'
import Image from 'next/image'
import { tw } from 'utils/classnames'

import { Link } from './link'
import { useCoinsPageLoggedOutQuery } from '@/gen/coins'

export function produceAlternatingArray<T1, T2>(...arrays: [Array<T1>, Array<T2>]): Array<T1 | T2> {
  const largestLength = Math.max(...arrays.map(a => a.length))
  const longestIndex = arrays.map(a => a.length).indexOf(largestLength)
  const longest = arrays[longestIndex]

  return longest.flatMap((_, index) => arrays.map(array => array[index]).filter(Boolean))
}

export function LoggedOutItems() {
  const { data, isPending } = useCoinsPageLoggedOutQuery()

  const classes = data?.coinsPopularProducts.classes ?? []
  const crafts = data?.coinsPopularProducts.crafts ?? []
  const items = produceAlternatingArray(classes, crafts).slice(0, 35)

  return (
    !isPending && (
      <section className="relative grid grid-cols-2 gap-5 pt-10 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7">
        {items.map((item, index) => (
          <Link
            href={item.url}
            key={`${item.id}_${index}`}
            className={tw(
              'relative block aspect-video w-full',
              index === 34 && 'hidden lg:block',
              index === 33 && 'md:hidden lg:block',
            )}
          >
            <Image fill src={item.image} alt={item.title} />
          </Link>
        ))}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-0 bottom-0 h-64 bg-gradient-to-b from-transparent to-cf-grey-50"
        />
      </section>
    )
  )
}
